/* Mimi Shape cart (doc §4): drawer dialog, add to cart, quantity, "לשנות מידה" (finder → replace
   the line), the complementary product (shared by the product page and the cart). Loaded on every page. */
(() => {
  const Mimi = (window.Mimi = window.Mimi || {});
  const SECTION = 'mimi-cart-drawer';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const dlg = $('[data-m-cart]');
  const body = dlg && $('[data-m-cart-body]', dlg);
  let opener = null;

  /* Measurements as visible line-item properties ("מותן (ס״מ)": "74"), only the ones this product's chart uses */
  Mimi.measurementProps = (chart) => {
    const values = Mimi.measurements && Mimi.measurements.get();
    const parsed = Mimi.parseChart && Mimi.parseChart(chart);
    const names = Mimi.propertyNames || {};
    if (!values || !parsed) return {};
    const props = {};
    parsed.measurements.forEach((k) => { if (values[k] && names[k]) props[names[k]] = String(values[k]); });
    return props;
  };

  const post = async (url, payload) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || (window.cartStrings && window.cartStrings.error) || '');
    return json;
  };
  const sections = () => [SECTION, 'cart-icon-bubble'];

  const render = (sectionsHtml) => {
    if (!sectionsHtml) return;
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (sectionsHtml[SECTION] && body) {
      const fresh = parse(sectionsHtml[SECTION]);
      const current = $(`#shopify-section-${SECTION}`, body);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      Mimi.renderDelivery && Mimi.renderDelivery(body);
      Mimi.initComplements(body);
    }
    if (sectionsHtml['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const fresh = parse(sectionsHtml['cart-icon-bubble']);
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }
  };

  Mimi.cart = {
    open(mode = 'view', from) {
      if (!dlg) { location.href = window.routes.cart_url; return; }
      opener = from || document.activeElement;
      $('[data-m-cart-title-added]', dlg).hidden = mode !== 'added';
      $('[data-m-cart-title-view]', dlg).hidden = mode === 'added';
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('m-cart-open');
      $('#MimiCartTitle', dlg).focus({ preventScroll: true });
    },
    close() { if (dlg && dlg.open) dlg.close(); },
    async change(key, quantity) {
      const err = body && $('[data-m-cart-error]', body);
      try {
        const json = await post(`${window.routes.cart_change_url}.js`, { id: key, quantity, sections: sections(), sections_url: location.pathname });
        render(json.sections);
      } catch (e) { if (err) { err.textContent = (Mimi.strings && Mimi.strings.error) || e.message; err.hidden = false; } }
    },
  };

  Mimi.addToCart = async (items, { open = true } = {}) => {
    const json = await post(`${window.routes.cart_add_url}.js`, { items, sections: sections(), sections_url: location.pathname });
    render(json.sections);
    document.dispatchEvent(new CustomEvent('mimi:cart-added', { detail: json }));
    if (open) Mimi.cart.open('added');
    return json;
  };

  /* "לשנות מידה": remove the line, add the same product in the new size with the same quantity */
  const replaceLine = async (line, size) => {
    if (line.options[line.sizeIndex] === size) return;
    const target = line.variants.find((v) => v.available && v.options.every((o, i) => (i === line.sizeIndex ? o === size : o === line.options[i])));
    const err = $('[data-m-cart-error]', body);
    if (!target) return;
    try {
      await post(`${window.routes.cart_change_url}.js`, { id: line.key, quantity: 0 });
      await Mimi.addToCart([{ id: target.id, quantity: line.quantity, properties: Mimi.measurementProps(line.chart) }], { open: false });
      Mimi.cart.open('view');
    } catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
  };

  /* Complementary product (doc 2.8 / 4.2): its size comes from her measurements against ITS OWN chart */
  Mimi.initComplements = (root = document) => {
    $$('[data-m-complement]', root).forEach((row) => {
      if (row.dataset.ready) return; row.dataset.ready = '1';
      const c = JSON.parse($('[data-m-complement-json]', row).textContent);
      const err = $('[data-m-complement-error]', row);
      const add = $('[data-m-complement-add]', row);
      const addVariant = async (v) => {
        add.setAttribute('aria-busy', 'true'); err.hidden = true;
        try { await Mimi.addToCart([{ id: v.id, quantity: 1, properties: Mimi.measurementProps(c.chart) }]); }
        catch (e) { err.textContent = Mimi.strings && Mimi.strings.error ? Mimi.strings.error : e.message; err.hidden = false; }
        finally { add.removeAttribute('aria-busy'); }
      };
      // "בחירת מידה": the finder for THIS product and its own chart (her saved measurements are
      // filled in), so the size is computed for this product, never copied from another.
      add.addEventListener('click', () => {
        if (typeof Mimi.openFinder !== 'function') { location.href = c.url; return; }
        Mimi.openFinder({
          opener: add, chart: c.chart, title: c.title,
          onSelect: (size) => {
            const chosen = c.variants.find((x) => x.available && x.options[c.sizeIndex] === size);
            if (chosen) addVariant(chosen); else location.href = c.url;
          },
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => Mimi.initComplements(document));

  /* Bag icon opens the drawer ("הסל שלך") */
  document.addEventListener('click', (e) => {
    const bag = e.target.closest('#cart-icon-bubble');
    if (e.target.closest('#MimiMenu')) return; // the menu closes itself first, then opens the cart
    if (bag && dlg) { e.preventDefault(); Mimi.cart.open('view', bag); }
  });

  if (!dlg) return;
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg || e.target.closest('[data-m-cart-close]')) { Mimi.cart.close(); return; }
    const toggle = e.target.closest('[data-m-measure-toggle]');
    if (toggle) {
      const box = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open)); box.hidden = open; return;
    }
    const qty = e.target.closest('[data-m-qty]');
    if (qty) { const li = qty.closest('[data-m-cart-line]'); Mimi.cart.change(li.dataset.mCartLine, Math.max(0, parseInt(qty.dataset.mQty, 10))); return; }
    const change = e.target.closest('[data-m-change-size]');
    if (change) {
      const line = JSON.parse($('[data-m-line-json]', change.closest('[data-m-cart-line]')).textContent);
      Mimi.openFinder({ opener: change, chart: line.chart, title: line.title, onSelect: (size) => replaceLine(line, size) });
    }
  });
  dlg.addEventListener('close', () => {
    document.documentElement.classList.remove('m-cart-open');
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  });
})();
